module.exports = __webpack_public_path__ + "img/home-icon-int-white.31a5d220.svg";